<button (click)="initWish()" class="transition-transform active:scale-95">
  <img
    [src]="isInWish() ? 'assets/icons/favourites/active.svg' : 'assets/icons/favourites/default.svg'"
    alt="favourite icon"
    class="h-8 w-8 transition-opacity duration-200"
    [class.opacity-100]="isInWish()"
    [class.opacity-60]="!isInWish()"
  />
</button>
